import type { PluginFunc } from 'dayjs';

/**
 * dayjs plugin that converts to UTC with `.utc()` whenever `.tz('UTC')` is asked for.
 *
 * cal-heatmap converts every date it draws with `.tz(date.timezone)`, and we pin that to UTC. dayjs'
 * timezone plugin derives the offset from the viewer's own clock, so it comes out an hour off - even
 * for UTC - when the viewer's daylight-saving change falls between their local midnight and UTC
 * midnight. In Sydney, where DST began at 02:00 on Sunday 4 Oct 2026, 4 Oct 00:00Z became 3 Oct 23:00:
 * Sunday's cell was drawn over Saturday's and the two days' energy was summed into one. UTC has no
 * offset to derive.
 *
 * cal-heatmap bundles its own dayjs, so install this with `cal.extendDayjs()`; extending the app's
 * dayjs does not reach it. dayjs marks a plugin installed on its first `extend()`, whichever dayjs
 * that is, so in the app do not extend any other dayjs with it either.
 */
export const utcTimezonePlugin: PluginFunc = (_option, dayjsClass) => {
    const proto = dayjsClass.prototype as any;
    const tz = proto.tz;
    proto.tz = function (timezone?: string, keepLocalTime?: boolean) {
        return timezone === 'UTC' ? this.utc(keepLocalTime) : tz.call(this, timezone, keepLocalTime);
    };
};
